import Select from "../Select";

export function PerPage({ limit, setLimit }) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span
        style={{ marginBottom: "12px", fontSize: "12px", marginRight: "10px" }}
      >
        Rows per page:
      </span>
      <Select
        placeholder="Rows per page"
        list={[
          { label: 10, value: 10 },
          { label: 20, value: 20 },
          { label: 50, value: 50 },
          { label: 75, value: 75 },
          { label: 100, value: 100 },
          { label: 500, value: 500 },
        ]}
        value={limit}
        onChange={e => {
          setLimit(e.target.value);
        }}
      />
    </div>
  );
}
